import http from '@/utils/Http'

const searchState = () => {
    return {
        current_page: 1,
        per_page: 0,
        total_entries: 0,
        entries: []
    }
};

const BASE_PATH = '/v1/proposals';

const loadEntries = (path) => {
    return new Promise((resolve, reject) => {
        http.get(path)
            .then(({data}) => resolve(data))
            .catch(reject);
    })
};

export default {
    namespaced: true,
    state: {
        search: searchState(),
        brokers: [],
        seller_accounts: [],
    },
    getters: {
        search(state) {
            return state.search;
        },
        brokers: state => state.brokers,
        seller_accounts: state => state.seller_accounts,
    },
    mutations: {
        resetSearch(state, defaultValues = {}) {
            state.search = Object.assign({}, searchState(), defaultValues);
        },
        setSearch(state, payload) {
            state.search = payload;
        },
        setBrokers(state, payload) {
            state.brokers = payload
        },
        setSellerAccounts(state, payload) {
            state.seller_accounts = payload
        }
    },
    actions: {
        async filter({commit, state}, path) {
            return new Promise((resolve, reject) => {
                loadEntries(path)
                    .then(data => {
                        commit('setSearch', Object.assign({}, state.search, data));
                        resolve(data);
                    })
                    .catch(reject);
            })
        },
        async loadMore({}, path) {
            return loadEntries(path);
        },
        async resetSearch({commit}, defaultValues = {}) {
            commit('resetSearch', defaultValues);
        },
        async destroy({commit}, id) {
            return new Promise((resolve, reject) => {
                http.delete(`${BASE_PATH}/${id}`)
                    .then(({data}) => resolve(data))
                    .catch(reject);
            })
        },
        async destroyAddendum({commit}, id) {
            return new Promise((resolve, reject) => {
                http.delete(`${BASE_PATH}/destroy_addendum/${id}`)
                    .then(({data}) => resolve(data))
                    .catch(reject);
            })
        },
        async destroyFixing({commit}, id) {
            return new Promise((resolve, reject) => {
                http.delete(`${BASE_PATH}/destroy_fixing/${id}`)
                    .then(({data}) => resolve(data))
                    .catch(reject);
            })
        },
        async load({commit}, id) {
            return new Promise((resolve, reject) => {
                http.get(`${BASE_PATH}/${id}`)
                    .then(({data}) => resolve(data))
                    .catch(reject);
            })
        },
        // Handoff MCP -> UI: carrega um rascunho preparado por um agente (via /mcp).
        async loadDraft({commit}, token) {
            return new Promise((resolve, reject) => {
                http.get(`${BASE_PATH}/load_draft/${token}`)
                    .then(({data}) => resolve(data))
                    .catch(err => reject(err));
            })
        },
        async loadBrokers({commit}) {
            return new Promise((resolve, reject) => {
                http.get(`${BASE_PATH}/load_brokers`)
                    .then(({data}) => {
                        commit('setBrokers', data);
                        resolve(data);
                    })
                    .catch(reject);
            })
        },
        async loadCustomerAccounts({commit}, customer_id) {
            return new Promise((resolve, reject) => {
                http.get(`${BASE_PATH}/load_customer_accounts/${customer_id}`)
                    .then(({data}) => {
                        commit('setSellerAccounts', data);
                        resolve(data);
                   })
                    .catch(reject);
            })
        },
        async save({commit}, payload) {
            // draft_token (handoff MCP, 16b) vai no TOPO do request — o Rails o lê
            // em params[:draft_token] para fechar o loop de status. Fora do objeto
            // proposal (não é coluna).
            const draftToken = payload && payload._draft_token;
            if (payload && '_draft_token' in payload) delete payload._draft_token;

            return new Promise((resolve, reject) => {
                if(payload.id) {
                    http.put(`${BASE_PATH}/${payload.id}`, {proposal: payload})
                        .then(({data}) => resolve(data))
                        .catch(err => reject(err));
                } else {
                    http.post(BASE_PATH, {proposal: payload, draft_token: draftToken})
                        .then(({data}) => resolve(data))
                        .catch(err => reject(err));
                }
            })
        }
    }
}
